/*
 *  -----------------------------------------------------------------------
 *    <copyright file="study-contractual-info.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React from 'react';
import moment from 'moment';

import { useTranslation } from 'hooks';
import { StudyFields } from 'queries/generated/fragments.generated';
import { formatDateUTC_DEPRECATED } from 'utils/convertor';

import 'views/components/admin/studies/admin-study.scss';

const StudyContractualInfo = ({ study }: { study: StudyFields }) => {
    const { t } = useTranslation();

    const data = {
        RFPStartDate: moment(study.riskAssessmentRfpStartDate).year() > 1 ? study.riskAssessmentRfpStartDate : null,
        ISMPStartDate: moment(study.riskAssessmentIsmpStartDate).year() > 1 ? study.riskAssessmentIsmpStartDate : null,
        CMFirstDataLoadDate:
            moment(study.centralMonitoringFirstDataLoadDate).year() > 1
                ? study.centralMonitoringFirstDataLoadDate
                : null,
        AwardStartDate:
            moment(study.riskAssessmentAwardStartDate).year() > 1 ? study.riskAssessmentAwardStartDate : null,
        CMReleaseDate:
            moment(study.centralMonitoringReleaseDate).year() > 1 ? study.centralMonitoringReleaseDate : null,
    };

    return (
        <div className="study-settings-wrapper">
            <div className="d-flex">
                <div className="data-wrap">
                    <div className="row">
                        <span className="title">
                            <strong>{t('admin:RFPStartDate')}:</strong>
                        </span>
                        <span className="value">
                            {formatDateUTC_DEPRECATED(data.RFPStartDate, true, 'DD-MMM-YYYY')}
                        </span>
                    </div>
                    <div className="row">
                        <span className="title">
                            <strong>{t('admin:RAMAwardStartDate')}:</strong>
                        </span>
                        <span className="value">
                            {formatDateUTC_DEPRECATED(data.AwardStartDate, true, 'DD-MMM-YYYY')}
                        </span>
                    </div>
                    <div className="row">
                        <span className="title">
                            <strong>{t('admin:RAMISMPStartDate')}:</strong>
                        </span>
                        <span className="value">
                            {formatDateUTC_DEPRECATED(data.ISMPStartDate, true, 'DD-MMM-YYYY')}
                        </span>
                    </div>
                </div>
                <div className="data-wrap">
                    <div className="row">
                        <span className="title">
                            <strong>{t('admin:CMReleaseDate')}:</strong>
                        </span>
                        <span className="value">
                            {formatDateUTC_DEPRECATED(data.CMReleaseDate, true, 'DD-MMM-YYYY')}
                        </span>
                    </div>
                    <div className="row">
                        <span className="title">
                            <strong>{t('admin:CMFirstDataLoadDate')}:</strong>
                        </span>
                        <span className="value">
                            {formatDateUTC_DEPRECATED(data.CMFirstDataLoadDate, true, 'DD-MMM-YYYY')}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StudyContractualInfo;
